/* eslint-disable */ 
import './components.css';
import React, {useEffect, useState} from 'react';
import Form from './Form';
import { Redirect } from 'react-router-dom';
import { useStateValue } from '../ContextApi/StateProvider';

const ExerciseEdit = (props) => {
    const [errors, setErrors] = useState([]);
    const [title, setTitle] = useState("");
    const [exercise, setExercise] = useState({});
    const [initialState, dispatch] = useStateValue();
    const authUser = JSON.parse(initialState.authenticatedUser);

    useEffect(()=>{
        initialState.ExerciseRequests.getExercise(
            props.match.params.workoutId,
            props.match.params.id,
            authUser.emailAddress, 
            authUser.password
        ).then(
            response => setExercise(response)
        ).catch(err => {
            console.log('Error' + err);
        })
    }, [])

    const change = (event, setState) => {
        const value = event.target.value;
        setState(value);
    }

    const submit = () => {
        let workoutId = props.match.params.workoutId;
        let id = exercise.id;
        const obj = {id, title, workoutId};
        initialState.ExerciseRequests.updateExercise(obj, authUser.emailAddress, authUser.password)
            .then((response)=> {
                if (response === "success"){
                    console.log(`Exercise successfully updated`)
                    props.history.push(`/workouts/${props.match.params.workoutId}/exercises/${props.match.params.id}`);
                } else if (response === "forbidden") {
                    setErrors([...errors, "You must be logged in to edit an exercise."]);
                } else {
                    setErrors([...errors, response])
                    console.log(errors);
                }
            }).catch(err => {
                setErrors([...errors, err])
            })
    }

    const cancel = () => {
        props.history.push(`/workouts/${props.match.params.workoutId}/exercises/${props.match.params.id}`);
    }

    return (
        authUser ? (
            <div className="container-2025 section-2025 prose-2025">
                <Form 
                    cancel={cancel}
                    cancelButtonText="Back"
                    submit={submit}
                    submitButtonText="Edit Exercise"
                    elements={() => (
                        <React.Fragment>
                                <h3 className='new-exercise-header'><i className="far fa-edit"></i> Edit Exercise</h3>
                                {errors.map((error, i) => <p className='excercise-edit-error-message' key={i}>{error}</p>)}
                                <div className='form-row'>
                                    <label className='form-label' htmlFor="title">Exercise Name</label>
                                    <input
                                        className="input-2025"
                                        id="title"
                                        name="title"
                                        type="text"
                                        onChange={(e)=> change(e, setTitle)} 
                                        placeholder={exercise.title}
                                        maxLength="18"
                                        required
                                        />
                                </div>
                        </React.Fragment>
                )} />
            </div>
        ) : (
            <Redirect to="/sign-in" />
        )
    )
}


export default ExerciseEdit;